import React from "react";

function SecurityTokenOffering() {
  return (
    <>
      {" "}
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Xeer for Your Security Token Offering?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Our approach ensures that your tokenization process meets
                  regulatory standards and offers maximum security. With a team
                  of blockchain and legal experts, we deliver compliant,
                  end-to-end STO solutions tailored to your asset type, business
                  needs, and investor goals.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default SecurityTokenOffering;
